module.exports = __webpack_public_path__ + "static/media/image10.c39cf466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/image10.jpg
// module id = 407
// module chunks = 0